import React, { useRef } from "react";
import html2pdf from "html2pdf.js";

export default function PanReceiptModal({
  receiptData = null,
  isOpen = false,
  onClose = () => {},
  title = "PAN Application Receipt",
  logoUrl = "http://localhost:3000/assets/images/logo/2.png",
}) {
  const receiptRef = useRef();

  if (!isOpen) return null;

  const data = receiptData || {
    id: "N/A",
    name: "N/A",
    aadhar: "N/A",
    mobile: "N/A",
    fathername: "N/A",
    dob: "N/A",
    email: "N/A",
    gender: "N/A",
    status: "pending",
    created_at: "N/A",
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
      case "success":
        return "text-success";
      case "rejected":
      case "failed":
        return "text-danger";
      case "pending":
        return "text-warning";
      default:
        return "text-secondary";
    }
  };

  const handlePrint = () => {
    const printContents = receiptRef.current.innerHTML;
    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <head>
          <title>PAN Receipt</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
        </head>
        <body>${printContents}</body>
      </html>
    `);
    win.document.close();
    win.print();
  };

  const handleDownload = () => {
    html2pdf().set({
      margin: 0.5,
      filename: "pan-receipt.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    }).from(receiptRef.current).save();
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-fullscreen-md-down"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h4 className="main-title">{title}</h4>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          {/* Body */}
          <div className="modal-body p-0">
            <div className="container invoice-container" ref={receiptRef}>
              <div className="card">
                <div className="card-body">
                  {/* Header */}
                  <table className="table">
                    <tbody>
                      <tr>
                        <td style={{    transform: 'translateY(-9)'
}}>
                          <img
                            src={logoUrl}
                            alt="Logo"
                            style={{ width: "185px", height: "60px", objectFit: "contain" }}
                          />
                          <address className="mt-2">
                            Customer Copy – PAN Application
                          </address>
                        </td>
                        <td className="text-end">
                          <h4 className="text-primary">RECEIPT</h4>
                          <p>Receipt #{data.id}</p>
                          <p>{data.created_at}</p>
                          <p>
                            <strong className={getStatusClass(data.status)}>
                              {data.status?.toUpperCase()}
                            </strong>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Details */}
                  <table className="table table-bordered">
                    <tbody>
                      <ReceiptRow label="Application ID" value={data.id} />
                      <ReceiptRow label="Name" value={data.name} />
                      <ReceiptRow label="Aadhar Number" value={data.aadhar} />
                      <ReceiptRow label="Mobile Number" value={data.mobile} />
                      <ReceiptRow label="Father Name" value={data.fathername} />
                      <ReceiptRow label="Date of Birth" value={data.dob} />
                      <ReceiptRow label="Email" value={data.email} />
                      <ReceiptRow label="Gender" value={data.gender} />
                      <ReceiptRow label="Status" value={data.status} isStatus />
                      <ReceiptRow label="Applied Date" value={data.created_at} />
                    </tbody>
                  </table>

                  {/* Note */}
                  <div className="text-center mt-3 p-3 bg-light rounded">
                    <strong>Note:</strong> This is a computer-generated receipt.
                    <br />
                    <small>No signature required.</small>
                  </div>
                </div>
              </div>

              {/* Footer Buttons */}
              <div className="invoice-footer text-end mt-3">
                <button className="btn btn-primary m-1" onClick={handlePrint}>
                  Print
                </button>
                <button className="btn btn-success m-1" onClick={handleDownload}>
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* Row Component */
const ReceiptRow = ({ label, value, isStatus }) => (
  <tr>
    <th>{label}</th>
    <td>
      {isStatus ? (
        <strong>{value?.toUpperCase()}</strong>
      ) : (
        value
      )}
    </td>
  </tr>
);
